/**
 * Report-related constants
 *
 * Extracted from useAdminReports.js for reusability.
 */

// Time filter options for report queries
export const TIME_OPTIONS = ['Past 24 hours', 'Past 7 Days', 'Past Month', 'All Time'];

// Sentinel stored in a report's `reporter` field when the submitter stayed
// anonymous. The Lambdas compare against this exact string (reportUtils.js sets
// it; reports.js and ReportSubmission branch on it), so it is a protocol value,
// not display copy — never translate what gets stored. Translate at the point
// of display instead, via `reports:details.anonymous`.
export const ANONYMOUS_REPORTER = 'Anonymous';

// Default HRO (High Reliability Organization) categories
export const DEFAULT_HROS = ['PF', 'RS', 'SO', 'CR', 'DE'];

// Time filter indices
export const TIME_FILTER = {
  PAST_24_HOURS: 0,
  PAST_7_DAYS: 1,
  PAST_MONTH: 2,
  ALL_TIME: 3,
  CUSTOM: 4,
};
